<template>
  <div class="g-wrap">
    <div class="page-activity">
      <div class="page-activity-content">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
.g-wrap {
  display: flex;
  width: 100%;
  .page-activity {
    position: relative;
    flex: 1;
    overflow: hidden auto;
  }
}
</style>